/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import { formatNumber } from "../../../../helper/numberFormatter";

const InventoryReportTable = (props) => {
  return (
    <div className={classes.root}>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className="global-custom-sorting-header">
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("WAREHOUSE")}
                </b>
              </TableCell>
              <TableCell className="global-custom-sorting-header">
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("INVENTORY_TYPE_ID")}
                </b>
              </TableCell>
              <TableCell className="global-custom-sorting-header">
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("CUSTOMER_ID")}
                </b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("productId");
                }}
              >
                <b>{props.t("FEATURE_CODE")}</b>
                {/* Sort indication */}
                {props.sortBy === "productId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("productName");
                }}
              >
                <b>{props.t("PRODUCT_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "productName" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell className="global-custom-sorting-header">
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("DESCRIPTION")}
                </b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                title={props.t("TOTAL_ATP_FULL")}
              >
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("TOTAL_ATP")}
                </b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                title={props.t("TOTAL_QOH_FULL")}
              >
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("TOTAL_QOH")}
                </b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                title={props.t("ORDERED_QUANTITY")}
              >
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("ORDERED_QTY")}
                </b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                title={props.t("MINIMUM_STOCK")}
              >
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("MINIMUM_STK")}
                </b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                title={props.t("REORDERED_QUANTITY")}
              >
                <b style={{ paddingTop: "8px", display: "block" }}>
                  {props.t("REORDERED_QTY")}
                </b>
              </TableCell>
              {/* <TableCell className="global-custom-sorting-header">
                                    <b style={{ paddingTop: '8px', display: 'block' }}>QOH Minus Min Stock</b>
                                </TableCell>
                                <TableCell className="global-custom-sorting-header">
                                    <b style={{ paddingTop: '8px', display: 'block' }}>ATP Minus Min Stock</b>
                                </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.list.map((row, index) => (
              <TableRow
                key={index}
                // className={classes.rowClass}
                // onClick={(e) => { navigate(`/order/${row.orderId}`) }}
              >
                <TableCell
                  style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                >
                  {row.facilityName}
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                >
                  {row.inventoryType}
                </TableCell>
                <TableCell>{row.customerId}</TableCell>
                <TableCell
                  style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                >
                  {row.productCode}
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                >
                  {row.productName}
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                >
                  {row.productDescription}
                </TableCell>
                <TableCell>{row.totalAvailableToPromise}</TableCell>
                <TableCell>{row.totalQuantityOnHand}</TableCell>
                <TableCell>{row.quantityOnOrder}</TableCell>
                <TableCell>{row.minimumStock}</TableCell>
                <TableCell>{row.reorderQuantity}</TableCell>
                {/* <TableCell>{row.offsetQOHQtyAvailable}</TableCell>
                                        <TableCell>{row.offsetATPQtyAvailable}</TableCell> */}
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.list.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  {props.t("NO_DATA_FOUND")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalInventoryCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalInventoryCount)}
          </label>
          <label>
            {props.t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          <Pagination
            count={Math.ceil(props.totalInventoryCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(InventoryReportTable);
